var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63342 6.25543V6.07011M2.63342 6.07011V15.7499C2.63342 17.0004 3.64714 18.014 4.89764 18.014H7.7761M2.63342 6.07011L4.75494 3.16242C5.32327 2.38346 6.2295 1.92285 7.19376 1.92285H15.1023C16.3527 1.92285 17.3665 2.93658 17.3665 4.18707V12.3969",
    stroke: "#404553",
    strokeWidth: 1.36842
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3626 11.106V16.4966C17.3626 17.3303 16.6868 18.0061 15.8531 18.0061H9.84412",
    stroke: "#404553",
    strokeWidth: 1.36842
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7922 15.2704V18.0769H7.39843L7.4657 15.2868L7.47496 14.9025L7.15025 14.6967C6.50149 14.2855 6.0025 13.8804 5.66075 13.3894C5.32948 12.9135 5.11713 12.3151 5.11719 11.4639C5.11728 9.9481 5.71349 8.98644 6.43566 8.39115C6.93745 7.97752 7.5121 7.73173 8.01848 7.61475V11.4638V12.1431H8.69775H9.79741H10.4767V11.4638V7.66777C11.9825 8.12774 13.3689 9.6229 13.3689 11.4638C13.3689 12.4206 13.092 13.0814 12.7097 13.5607C12.3182 14.0515 11.7808 14.3954 11.2008 14.6474L10.7922 14.825V15.2704Z",
    fill: "#00B4D7",
    stroke: "#404553",
    strokeWidth: 1.23158
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3095 3.15039H14.3924V3.76724C14.4891 3.79787 14.5822 3.83645 14.671 3.88225L15.1015 3.45176L15.8672 4.21747L15.4392 4.64549C15.4887 4.73987 15.53 4.83921 15.5622 4.94258H16.1845V6.00966H15.5622C15.53 6.11302 15.4887 6.21234 15.4393 6.30671L15.8673 6.73479L15.1016 7.5005L14.6711 7.06998C14.5823 7.11581 14.4891 7.15441 14.3924 7.18503V7.80185H13.3095V7.18517C13.2154 7.15539 13.1247 7.11806 13.038 7.07388L12.6114 7.5005L11.8456 6.73479L12.2662 6.31425C12.215 6.21762 12.1723 6.11576 12.1393 6.00966H11.5171V4.94258H12.1393C12.1723 4.83651 12.215 4.73468 12.2662 4.63809L11.8456 4.21747L12.6113 3.45176L13.0379 3.87843C13.1246 3.83423 13.2154 3.79689 13.3095 3.76712V3.15039ZM13.8513 6.13942C14.2176 6.13942 14.5146 5.84244 14.5146 5.47609C14.5146 5.10976 14.2176 4.81278 13.8513 4.81278C13.4849 4.81278 13.1879 5.10976 13.1879 5.47609C13.1879 5.84244 13.4849 6.13942 13.8513 6.13942Z",
    fill: "#404553"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsIcon);
export default __webpack_public_path__ + "static/media/claims-icon.9b08a7c67454a70f7ee244ce8cfd9d03.svg";
export { ForwardRef as ReactComponent };